import { fetchPurchaseOrders, selectPurchaseOrder, resetCurrentPurchaseOrder, setDefaultDays } from '../../actions/purchaseOrders_actions';
import { selectReceiveHistory, resetCurrentReceiveHistory, fetchReceiveHistory, fetchReceiveHistoryByDate } from '../../actions/receive_actions';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import PurchasePaymentList from '../../components/Purchase/purchasePaymentList'

let purchasePaymentList = reduxForm({
  form: 'purchasePaymentList',
})(PurchasePaymentList);

const selector = formValueSelector('purchasePaymentList');

function mapStateToProps(state) {
    const Days = selector(state, 'Days');
    const FromDate = selector(state, 'FromDate');
    const ToDate = selector(state, 'ToDate');
    return {
        Days,
        FromDate,
        ToDate,
        currentReceiveHistory: state.receives.fetchedReceiveHistory,
        isLoading: state.receives.isfetchingReceiveHistory,
        error: state.receives.fetchReceiveHistoryError,
        warehouse : state.header.selectedWarehouse,
        company : state.header.selectedCompany,
      };
}


export default connect(mapStateToProps, { selectReceiveHistory, resetCurrentReceiveHistory, fetchPurchaseOrders,
  fetchReceiveHistory, fetchReceiveHistoryByDate, setDefaultDays })(purchasePaymentList);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchasePaymentList.jsx